import back5 from "../../../../../imgs/back5.png";
import { useNavigate } from "react-router-dom";

import { useSelector } from "react-redux";
import Nav from "../../navbar";
import { useState } from "react";
import { Select } from "antd";
import { PlusCircleFilled } from "@ant-design/icons";

const Listing = () => {
  const defaultImage =
    "https://t3.ftcdn.net/jpg/03/45/05/92/360_F_345059232_CPieT8RIWOUk4JqBkkWkIETYAkmz2b75.jpg";
  const productData = useSelector((state) => state?.product);
  console.log(productData);
  const router = useNavigate();
  const user = useSelector((state) => state.user);
  const QuotationFlow = useSelector((state) => state.QuotationFlow);
  const role = useSelector((state) => state.role);
  const [method, setMethod] = useState("exchange");

  const methods = [
    {
      value: "exchange",
      label: "Exchange",
    },
    {
      value: "return",
      label: "Return",
    },
  ];

  return (
    <>
      <div>
        <Nav />
        <div className="flex items-center justify-center bg-[#D9EFED] ">
          <div className="w-[95%] mt-[1rem] px-10 rounded-md mb-12">
            <div className="cursor-pointer flex w-full items-center justify-center">
              <img
                onClick={() => {
                  if (QuotationFlow) {
                    router("/Inventory/Quotations");
                    return;
                  }
                  if (user === "vendor-owner" && !QuotationFlow) {
                    router("/Inventory-Vendor-Orders");
                    return;
                  }

                  router("/Inventory-Vendor-Orders-Details");
                }}
                className="sm:w-[1.7rem] w-[1.3rem]"
                src={back5}
                alt=""
              />
              <h2 className="font-bold w-full sm:text-[1.8rem] sm:ml-2 ml-[1rem] text-[1.4rem]">
                Exchange/Return
              </h2>
            </div>

            <div>
              <div className="mt-3  rounded-md  p-[3rem] pt-[2rem] mb-3  sm:min-h-[360px] bg-[#F6F4F4] shadow-lg">
                <div
                  className={`
                        flex gap-4
                        
                     `}
                >
                  <div className="flex-1">
                    <h3 className="text-[0.93rem] font-semibold mb-2">
                      Product Detail :
                    </h3>

                    <div className="w-full  rounded-sm flex flex-col gap-4 bg-white p-4">
                      <div className="flex gap-4">
                        <img
                          src={
                            productData?.invproduct?.invproductgallaries?.find(
                              (gallery) => gallery?.isCoverImg
                            )?.image || defaultImage
                          }
                          alt={productData?.invproduct?.name}
                          className="w-24 h-24 rounded object-cover"
                        />
                        <div>
                          <h2 className="text-[0.95rem] font-semibold">
                            {productData?.invproduct?.name}
                          </h2>

                          <div className="flex justify-between items-center gap-12">
                            <p className="text-sm font-medium text-gray-600">
                              Order quantity
                            </p>
                            <p className="text-lg font-semibold">
                              {productData?.actualUnits}
                            </p>
                          </div>
                          {/* <div className="flex justify-between items-center gap-12">
                            <p className="text-sm font-medium text-gray-600">
                              Discount
                            </p>
                            <p className="text-sm font-semibold">
                              ${productData?.invproduct?.discount}
                            </p>
                          </div>
                          <div className="flex justify-between items-center gap-12">
                            <p className="text-sm font-medium text-gray-600">
                              Tax
                            </p>
                            <p className="text-sm font-semibold">
                              ${productData?.invproduct?.tax}
                            </p>
                          </div>
                          <div className="flex justify-between items-center gap-12">
                            <p className="text-sm font-medium text-gray-600">
                              Delivery
                            </p>
                            <p className="text-sm font-semibold">
                              ${productData?.invproduct?.delivery}
                            </p>
                          </div> */}

                          <div className="flex justify-between items-center gap-12 mt-1">
                            <p className="text-sm font-medium text-gray-600">
                              Current Rate
                            </p>
                            <p className="text-sm font-semibold">
                              $
                              {productData?.invadvanceprice !== null
                                ? productData?.invadvanceprice?.price
                                : productData?.prodBasePrice}
                              /{productData?.invproduct?.pricingUnit}
                            </p>
                          </div>
                        </div>
                      </div>

                      <div className="border-t border-gray-200 pt-2">
                        <p className="text-right text-lg font-semibold text-gray-800">
                          Total Amount ${productData?.totalAmount}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="w-full">
                  <div className="py-8">
                    {/* <h2 className="text-gray-600 text-[0.9rem] font-semibold mb-2">
                      Payment Term
                    </h2> */}
                    <div className="w-full  rounded-md px-3">
                      <div className="flex gap-10  items-center">
                        {methods?.map((item, index) => (
                          <div className="flex items-center justify-center ">
                            <input
                              type="radio"
                              value={item?.value}
                              className="mr-2 h-4 w-4 cursor-pointer text-green-500 focus:ring-green-400 focus:ring-opacity-50 rounded-full custom-radio"
                              checked={item?.value === method}
                              onChange={(e) => {
                                setMethod(item?.value);
                              }}
                            />
                            <label
                              htmlFor="gidOption"
                              className="cursor-pointer text-sm inline-flex items-center ml-2"
                            >
                              {item?.label}
                            </label>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>

                  <div className="bg-white w-full p-4">
                    <div className="w-[60%] mt-2 ">
                      <div className={`mt-2`}>
                        <h2 className="text-gray-600 text-[0.9rem] font-semibold mb-2">
                          Quantity for Exchange
                        </h2>

                        <input
                          type="text"
                          placeholder={"Quantity for Exchange"}
                          className=" lg:text-[1.1rem] w-[100%] bg-white border-[1px] border-[#C6CFE5] rounded-[0.3rem] p-2"
                        />
                      </div>

                      <div className={`mt-2`}>
                        <h2 className="text-gray-600 text-[0.9rem] font-semibold mb-2">
                          Select Reason
                        </h2>

                        <Select
                          placeholder="Reason"
                          optionFilterProp="children"
                          className="wow"
                          // value={type}
                          // onChange={(val) => setType(val)}
                          size="middle"
                          options={[
                            { value: "weight", label: "Weight" },
                            { value: "quantity", label: "Quantity" },
                          ]}
                        />
                      </div>

                      <div className="mt-2">
                        <h2 className="text-gray-600 text-[0.9rem] font-semibold mb-2">
                          Comments
                        </h2>

                        <textarea
                          placeholder="Comments"
                          // value={note}
                          // onChange={(e) => setNote(e.target.value)}
                          className=" lg:text-[1.1rem] w-[100%] bg-white border-[1px] border-[#C6CFE5] rounded-[0.3rem] p-2 mb-2"
                          rows={"5"}
                        />
                      </div>

                      <div className="w-full flex  flex-col ">
                        <h2 className="text-gray-600 text-[0.9rem] font-semibold mb-2">
                          Product Images
                        </h2>
                        <label
                          htmlFor="special"
                          //   className={`${
                          //     imageUrl.length >= 4
                          //       ? "hidden"
                          //       : "cursor-pointer w-full relative"
                          //   } `}
                          className={`
                              cursor-pointer w-full relative"
                           `}
                        >
                          <div className="lg:mb-5 lg:text-[1.1rem] w-[100%] bg-[white] border-[1px] border-[#c6cfe5] rounded-[0.5rem] p-2 mb-4 flex items-center">
                            <div>
                              <PlusCircleFilled className="text-primary text-2xl flex items-center justify-center" />
                            </div>
                            <p className="text-[#9CA6C2] ml-2">
                              Add Product Images
                            </p>
                          </div>
                          <input
                            type="file"
                            className="hidden w-[100%] cursor-pointer"
                            id="special"
                            accept="image/png, image/gif, image/jpeg"
                            // onChange={(e) => imageHandlerE(e, "other")}
                          />
                        </label>
                        {/* <div className=" grid grid-cols-3 gap-5">
                          {imageUrl

                            .filter((image) => !image.isCoverImg) // filter images where isCoverImg is false
                            .map((image, index) => (
                              <div
                                key={index + 1}
                                className="relative mb-4 border"
                              >
                                <img
                                  onClick={() => {}}
                                  className="w-full h-32 rounded-xl object-cover"
                                //   src={image.image} // Access the image URL from the object
                                  alt=""
                                />
                                <div
                                  className="absolute bottom-0 right-0 bg-white cursor-pointer"
                                //   onClick={() => {
                                //     if (editProduct) {
                                //       DeleteImage(image?.id);
                                //       return;
                                //     }
                                //     setImageUrl(
                                //       imageUrl.filter((img) => img !== image)
                                //     );
                                //   }}
                                >
                                  <img
                                    className="sm:w-[3rem] w-[2rem]"
                                    // src={trash}
                                    alt="delete"
                                  />
                                </div>
                              </div>
                            ))}

                          
                        </div> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex items-center justify-center pb-6 mt-4">
                <button
                  onClick={() => {}}
                  className="ml-5 cursor-pointer rounded-md pt-[0.5rem] pb-[0.5rem] pl-10 pr-10 text-white bg-primary w-[12rem]"
                >
                  Submit Request
                </button>
              </div>

              {/* 
              {errorModal && <ErrorModal setShow={setErrorModal} err={err} />}
             
              {showSuccessModal && (
                <SuccessModal
                  setShow={setShowSuccessModal}
                  err={err}
                  route={route}
                />
              )} */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Listing;
